import React, { Component } from 'react'

export default class NoGroupModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        return (
            <div className='opacity-overlay ' style={{ 'display': 'block' }}>
                <div className="container">
                    <div className="popup-wrapper">
                        <div className="col-xs-12 col-sm-4 popup-content">
                            <div>
                                <div className='modal-body'>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <h5 style={{textAlign: 'center'}}>There is no available customer group!</h5>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <a href="/toolkit" className='form-control' style={{width: "200px",margin: "auto",textAlign: "center"}}>Back</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/BenefitsLadder/NoGroupModal/NoGroupModal.jsx